import { FC, memo } from "react";
import { Calendar } from 'primereact/calendar';
import { DatepickerProps } from "./Datepicker.interface"
import { FloatLabel } from "primereact/floatlabel";

const Datepicker: FC<DatepickerProps> = ({ date, label, onChange }) => {
    return <FloatLabel>
        <Calendar className="prime-calendar-container" inputClassName="prime-calendar-input" inputId={label.replaceAll(' ', '_')} value={date} onChange={
            (e) => {
                console.log(e.value)
                e.value && onChange(e.value)
            }
        } showIcon showButtonBar  />
        <label htmlFor={label.replaceAll(' ', '_')}>{label}</label>
    </FloatLabel>

}
    
export default memo(Datepicker);